module.exports = __webpack_public_path__ + "img/logo-icon-w.ea509900.svg";